// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TracesIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TracesIcon" ref={forwardedRef} {...props}>
      <path d="M19 4H1v1.5h18z" />
      <path d="M8 7.5H1V9h7z" />
      <path d="M8 11h6v1.5H8z" />
      <path d="M19 14.5h-5V16h5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TracesIcon = /* @__PURE__ */ Object.assign(TracesIconComponent, {
  displayName: 'TracesIcon',
});
